import ReceiptLong from "@mui/icons-material/ReceiptLong";
import UploadFile from "@mui/icons-material/UploadFile";
import { Button, Tooltip } from "@mui/material";
import { DocumentType } from "generated-graphql/graphql";

interface AttachmentButtonProps {
  documentType: DocumentType;
  isExistingPayment: boolean;
  hasExistingDocument: boolean;
  hasFormDocument: boolean;
  tenantId?: string;
  onAttach: () => void;
  disabled?: boolean;
}

export function AttachmentButton({
  documentType,
  isExistingPayment,
  hasExistingDocument,
  hasFormDocument,
  tenantId,
  onAttach,
  disabled,
}: AttachmentButtonProps) {
  const isReceipt = documentType === DocumentType.Receipt;

  // Always show buttons for consistency
  const shouldShow = true;

  // Unified disabled logic - disable when appropriate
  const isDisabled =
    disabled || // Disable when explicitly disabled (e.g., Lob job in progress)
    !tenantId ||
    (isExistingPayment
      ? isReceipt
        ? hasExistingDocument || hasFormDocument // For existing payment receipts, disable if either exists
        : hasExistingDocument // For existing payment invoices, disable if existing exists
      : hasFormDocument); // For new payments, disable if form document exists

  // Unified text logic
  const buttonText = `Add ${isReceipt ? "Receipt" : "Invoice"}`;

  // Unified icon
  const buttonIcon = isReceipt ? <ReceiptLong /> : <UploadFile />;

  if (!shouldShow) return null;

  // Unified tooltip logic
  const tooltipText = disabled
    ? "Cannot upload documents while Lob job is in progress"
    : !tenantId
    ? "Select an organization before uploading documents"
    : isDisabled && tenantId
    ? isReceipt
      ? "Receipt already exists"
      : "Invoice already exists"
    : "";

  return (
    <Tooltip title={tooltipText} arrow>
      <span>
        <Button
          variant="outlined"
          disabled={isDisabled}
          onClick={onAttach}
          startIcon={buttonIcon}
          sx={{ height: 40, minHeight: 40 }}
        >
          {buttonText}
        </Button>
      </span>
    </Tooltip>
  );
}
